import CMSection from '@src/components/Atoms/CMSection';
import { devices } from '@src/styles/theme';
import styled from 'styled-components';
import QuoteSvg from '@src/assets/imgs/sponser/quotes.svg';
import Image from 'next/image';
const RareBlood = () => {
  return (
    <CMSection background="#F9F9F9">
      <Wrap>
        <Flex>
          <QuoteIcon />
          <PcBigTitle>백혈병 걸린 저희 어머니를 살려주세요...</PcBigTitle>
          <MbBigTitle>
            백혈병 걸린 저희 어머니를
            <br /> 살려주세요...
          </MbBigTitle>
          <QuoteReverseIcon />
        </Flex>
        <PcSubTitle>
          피플은 여러분의 안타까운 사연을 알리기 위해 노력하고 있습니다.
        </PcSubTitle>
        <MbSubTitle>
          피플은 여러분의 안타까운 사연을 알리기 위해
          <br /> 노력하고 있습니다.
        </MbSubTitle>
        <RareImagePc
          onClick={() => {
            window.open(
              'https://www.koreahealthlog.com/news/articleView.html?idxno=44132',
              '_blank'
            );
          }}
          width={222}
          height={222}
          src={'/imgs/sponser/rareBlood.svg'}
          alt={'rare'}
        />
        <RareImageMb
          onClick={() => {
            window.open(
              'https://www.koreahealthlog.com/news/articleView.html?idxno=44132',
              '_blank'
            );
          }}
          width={342}
          height={210}
          src={'/imgs/sponser/rareBlood-mb.svg'}
          alt={'rare'}
        />
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  padding: 110px 0;

  @media ${devices.tablet} {
    padding: 50px 24px;
  }
`;
const QuoteIcon = styled(QuoteSvg)`
  width: 70px;
  height: 60px;

  @media ${devices.tablet} {
    width: 28px;
    height: 24px;
  }
`;
const QuoteReverseIcon = styled(QuoteSvg)`
  transform: rotate(180deg);
  width: 70px;
  height: 60px;

  @media ${devices.tablet} {
    width: 28px;
    height: 24px;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;

  @media ${devices.tablet} {
    gap: 4px;
  }
`;

const PcBigTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  white-space: pre-wrap;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbBigTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: ${({ theme }) => theme.commonColor.black};
    text-align: center;
    font-family: 'NOTO';
    font-size: 24px;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
  }
`;

const PcSubTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  margin: 30px 0;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbSubTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: ${({ theme }) => theme.commonColor.black};
    text-align: center;
    font-family: 'Var';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }
`;

const RareImagePc = styled(Image)`
  width: 1200px;
  height: 440px;
  cursor: pointer;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const RareImageMb = styled(Image)`
  cursor: pointer;
  display: none;
  @media ${devices.tablet} {
    display: block;
  }
`;

export default RareBlood;
